import React from 'react';
import './Cards.css';

function CardItem(props) {
    return (
        <div className='cards__item__link' style={{ cursor: 'pointer' }}>
            <figure className='cards__item__pic-wrap' data-category={props.label}>
                <img
                    className='cards__item__img'
                    alt={props.title}
                    src={props.src}
                />
            </figure>
            <div className='cards__item__info'>
                <h5 className='cards__item__title'>{props.title}</h5>
                <p className='cards__item__text'>{props.text}</p>
                <div className='cards__item__details'>
                    <span className='cards__item__date'>{props.date}</span>
                    <span className='cards__item__location'>{props.location}</span>
                </div>
            </div>
        </div>
    );
}

export default CardItem;